import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CallLogList, { isMissed } from "@/components/CallLogList";

export default function CallLogs() {
  const [calls, setCalls] = useState([]);
  const load = () => api.get("/calls").then(({ data }) => setCalls(data));

  useEffect(() => {
    load();
  }, []);

  const missed = calls.filter((c) => isMissed(c) && !c.called_back_by).length;

  return (
    <div className="p-4 sm:p-6 md:p-10 max-w-[1000px]" data-testid="owner-calllogs">
      <div className="mb-6">
        <div className="mono text-xs uppercase tracking-widest text-[#FF5000]">
          Voice
        </div>
        <h1 className="font-heading text-3xl font-bold mt-2">Call logs</h1>
        <p className="text-slate-500 mt-1 text-sm">
          Every inbound and outbound call, across your team. Tap the phone
          button to call back: your phone rings first.
          {missed > 0 && (
            <span className="text-red-600 font-medium">
              {" "}
              {missed} missed call{missed === 1 ? "" : "s"} not returned yet.
            </span>
          )}
        </p>
      </div>

      <CallLogList calls={calls} owner canCreateTask onCalled={load} />
    </div>
  );
}
